import React, { useEffect, useState } from 'react';
import { Calendar, Clock, MapPin } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { weddingData } from '../mockData';

const Program = () => {
  const { language } = useLanguage();
  const content = weddingData[language].program;
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  return (
    <div className="min-h-screen pt-24 pb-20 bg-ivory">
      {/* Header - Pastel Luxe */}
      <section className="bg-gradient-to-br from-lilac-100 via-lilac-200 to-lilac-100 py-32 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 left-20 w-64 h-64 bg-gold-200 rounded-full filter blur-3xl animate-float" />
          <div className="absolute bottom-20 right-20 w-64 h-64 bg-lilac-200 rounded-full filter blur-3xl animate-float" style={{ animationDelay: '2s' }} />
        </div>

        <div className={`container mx-auto px-6 sm:px-8 lg:px-12 text-center relative z-10 transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <Calendar className="mx-auto text-gold-500 mb-8" size={64} />
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-playfair font-bold text-plum-900 mb-6">
            {content.title}
          </h1>
          <p className="text-xl text-plum-800 font-montserrat max-w-3xl mx-auto">
            {content.subtitle}
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-gold-500 to-transparent mx-auto rounded-full mt-8" />
        </div>
      </section>

      {/* Timeline */}
      <section className="py-20 bg-ivory">
        <div className="container mx-auto px-6 sm:px-8 lg:px-12">
          <div className="max-w-4xl mx-auto">
            {/* Timeline Line */}
            <div className="relative">
              {/* Vertical Line */}
              <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-lilac-200 via-gold-300 to-lilac-200 hidden md:block" />

              {/* Timeline Items */}
              {content.timeline.map((item, index) => (
                <div
                  key={index}
                  className={`relative flex flex-col md:flex-row items-start mb-12 transition-all duration-700 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                  style={{ transitionDelay: `${index * 150}ms` }}
                >
                  {/* Timeline Dot */}
                  <div className="hidden md:flex absolute left-8 w-4 h-4 bg-gold-500 rounded-full transform -translate-x-1/2 mt-8 shadow-gold" />

                  {/* Time */}
                  <div className="md:w-24 md:text-right md:pr-8 mb-4 md:mb-0">
                    <div className="flex items-center md:justify-end space-x-2 text-gold-600 font-montserrat font-semibold">
                      <Clock size={18} className="md:hidden" />
                      <span>{item.time}</span>
                    </div>
                  </div>

                  {/* Content Card */}
                  <div className="flex-1 md:ml-12 card-premium hover-lift">
                    <h3 className="text-2xl font-playfair font-bold text-plum-900 mb-3">
                      {item.title}
                    </h3>
                    <div className="flex items-center space-x-2 text-plum-700 mb-3">
                      <MapPin size={18} className="text-gold-500" />
                      <span className="font-montserrat">{item.location}</span>
                    </div>
                    <p className="text-plum-800 font-montserrat">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Coming Soon Note */}
            <div className="mt-16 text-center">
              <div className="inline-block bg-lilac-100 border border-lilac-200 rounded-full px-8 py-4">
                <p className="text-plum-800 font-montserrat italic">
                  {content.comingSoon}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Program;
